<template>
  <loading  v-if="statusLoading === 'true'"/>
  <div class="container mt-5 d-flex justify-content-center table-responsive " v-else>
     <table class="table table-striped table-hover mt-5 " >
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col"> مبلغ (ریال)</th>
        <th scope="col">عنوان بسته</th>
        <th scope="col">کد پیگیری تراکنش</th>
        <th scope="col">وضعیت پرداخت</th>
        <th scope="col">تاریخ و ساعت تراکنش</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for=" (list , index ) in transactions">
        <td> {{ index + 1 }}</td>
        <td data-label="مبلغ (ریال)" >{{ numberFormats(list?.transactions[0]?.amount) }}</td>
        <td data-label="عنوان بسته">{{ list?.panels[0]?.title }}</td>
        <td data-label="کد پیگیری تراکنش">{{ list?.transactions[0]?.ref_id }}</td>
        <td data-label="وضعیت پرداخت"><span class="text-success">{{ (list?.transactions[0]?.message == 'Paid') ? "پرداخت شده" : "" }}</span></td>
        <td data-label="تاریخ و ساعت تراکنش" >{{ DatePersianTime(list?.created_at) }}</td>
      </tr>
      <tr>
        <td colspan="10">
          <nav class="text-danger">
            <ul class="pagination  " style="justify-content: center;">
              <li class="page-item">
                <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                    class="fa fa-angle-double-right"></i></button>
                <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                    class="fa fa-angle-right"></i></button>
              </li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <li class="page-item">
                <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                        :disabled="!paginatetion.next_page_url" title="بعدی">
                  <i class="fa fa-angle-left"></i></button>

                <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.last_page_url)" title="اخرین"><i
                    class="fa fa-angle-double-left"></i></button>
              </li>
            </ul>
          </nav>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script setup>
import axios from "axios";
import {$ref} from "vue/macros";
import config from "../../../../config/config.json";
import {useToast} from "vue-toastification";
import {converDatePersian, DatePersianTime} from "../../../common/helpers/DatePersian";
import {numberFormats} from "../../../common/helpers/Number";
import Loading from "@/agent/components/Layout/loadings/index.vue";


let statusLoading = $ref('true');
setTimeout(() => {
  statusLoading = false;
}, 1500);

let transactions = $ref();
let url = `${config.BASE_URL}/agentTransactions`;
let paginatetion = $ref({})
const toast = useToast();
async function getPermissions() {
  try {
    const res = await axios.get(url);
    transactions = (res.data.status) ? res.data.data.data : ""
    makePaginatetion(res.data.data);

  } catch (e) {
    console.log(e)
  }
}

function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}

function myPaginate(urls) {

  url = urls;
  getPermissions()
}

getPermissions()
</script>



